import { render, staticRenderFns } from "./Return_details.vue?vue&type=template&id=e932d0fe&scoped=true&"
import script from "./Return_details.vue?vue&type=script&lang=js&"
export * from "./Return_details.vue?vue&type=script&lang=js&"
import style0 from "./Return_details.vue?vue&type=style&index=0&id=e932d0fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e932d0fe",
  null
  
)

export default component.exports